define('pwa/module/NetworkStatusModule',['require','marionette','pwa/view/module/network-status/NetworkStatusView','pwa/model/NetworkStatusModel'],function (require) {

    var Marionette = require('marionette');
    var NetworkStatusView = require('pwa/view/module/network-status/NetworkStatusView');
    var NetworkStatusModel = require('pwa/model/NetworkStatusModel');

    /**
     * @class NetworkStatusModule
     */
    return Marionette.Object.extend({

        _region: null,
        _model: null,

        /**
         * Inits instance
         */
        initialize: function () {
            this._region = this.getOption('layout').getNetworkStatusRegion();
            this._model = new NetworkStatusModel({
                status: window.navigator.onLine ? 'online' : 'offline',
            });

            this._region.show(new NetworkStatusView({
                model: this._model,
            }));

            var _this = this;
            window.addEventListener('online', function () {
                _this._model.set('status', 'online');
            });
            window.addEventListener('offline', function () {
                _this._model.set('status', 'offline');
            });
        },

    });

});
